import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bcl-token-list-table-row rounded" }
const _hoisted_2 = { class: "cell cell-rank pl-2 pl-md-4" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "cell cell-name px-1 px-md-3" }
const _hoisted_5 = { class: "token-name" }
const _hoisted_6 = { class: "cell cell-collection text-right px-1 px-md-3" }
const _hoisted_7 = { class: "cell cell-price px-1 px-md-3" }
const _hoisted_8 = { class: "d-flex d-md-block flex-space-between" }
const _hoisted_9 = { class: "mobile-label d-block d-md-none" }
const _hoisted_10 = { class: "cell cell-market-cap px-1 px-md-3 text-md-right" }
const _hoisted_11 = { class: "d-flex d-md-block flex-space-between" }
const _hoisted_12 = { class: "mobile-label d-block d-md-none" }
const _hoisted_13 = { class: "cell cell-address text-right px-1 px-md-3" }
const _hoisted_14 = { class: "cell cell-chart text-right pr-md-4" }
const _hoisted_15 = { class: "cell cell-link" }


import { useDisplay } from "vuetify";

import { useLiveTokenData } from "@/composables";

import { ROUTE_SALE } from "@/utils/constants";
import { parseCollectionName } from "@/utils/common";

import PriceDataFormatter from "@/components/Common/Pricing/PriceDataFormatter.vue";
import TokenLineChart from "@/components/Charts/TokenLineChart.vue";
import AddressChip from "../Common/AddressChip.vue";
import TokenLabel from "../Common/TokenLabel.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenListTableRow',
  props: {
  token: { type: Object, required: true },
  useCollectionRank: Boolean,
},
  setup(__props) {

const props = __props;

const { tokenData } = useLiveTokenData({
  token: props.token,
});

const { smAndDown } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _createElementVNode("div", {
        class: "rank",
        textContent: _toDisplayString(__props.useCollectionRank ? __props.token.collection_rank : __props.token.rank)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.token.symbol), 1)
    ]),
    _createElementVNode("td", _hoisted_6, [
      _createVNode(TokenLabel, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`collections.${_unref(parseCollectionName)(__props.token.collection)}.name`)), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("common.price")) + ": ", 1),
        _createVNode(PriceDataFormatter, {
          "price-data": _unref(tokenData).price_data,
          class: "justify-end",
          row: _unref(smAndDown)
        }, null, 8, ["price-data", "row"])
      ])
    ]),
    _createElementVNode("td", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("common.marketCapShort")) + ": ", 1),
        _createVNode(PriceDataFormatter, {
          bignumber: "",
          "price-data": _unref(tokenData).market_cap_data,
          class: "justify-end",
          row: _unref(smAndDown)
        }, null, 8, ["price-data", "row"])
      ])
    ]),
    _createElementVNode("td", _hoisted_13, [
      _createVNode(AddressChip, {
        address: __props.token.sale_address
      }, null, 8, ["address"])
    ]),
    _createElementVNode("td", _hoisted_14, [
      _createVNode(TokenLineChart, {
        "sale-address": __props.token.address,
        height: 60,
        "chart-type": "line",
        class: "ml-auto chart"
      }, null, 8, ["sale-address"])
    ]),
    _createElementVNode("td", _hoisted_15, [
      _createVNode(_component_RouterLink, {
        to: {
          name: _unref(ROUTE_SALE),
          params: { contractAddress: __props.token.sale_address },
        },
        class: "link"
      }, null, 8, ["to"])
    ])
  ]))
}
}

})